export default __webpack_public_path__ + "static/media/Mobile-Developer.d34aec07.svg";